export default "__VITE_ASSET__27d221bd__"